import React, { FC, useCallback, useState } from 'react';
import { ColorPicker, Input } from 'antd';
import CTag from '../../components/ui/CTag';
interface StateLabelValue {
  color?: string;
  title?: string;
}
type Props = {
  value?: StateLabelValue;
  onChange?: (value?: StateLabelValue) => void;
  editable?: boolean;
};

export const StateLabel: FC<Props> = ({ onChange, editable, value }) => {
  const [currentColor, setCurrentColor] = useState<string | undefined>(
    value?.color ?? '#1677ff',
  );
  const [currentTitle, setCurrentTitle] = useState<string | undefined>(
    value?.title,
  );
  const handleColorChange = useCallback(
    (newColor: any) => {
      try {
        const hexColor = newColor.toHexString();
        setCurrentColor(hexColor);
        onChange?.({ color: hexColor, title: currentTitle });
      } catch (e) {
        console.error('Invalid color', e);
      }
    },
    [currentTitle, onChange],
  );
  const handleTitleChange = useCallback(
    (text?: string) => {
      setCurrentTitle(text);
      onChange?.({ color: currentColor, title: text });
    },
    [currentColor, onChange],
  );
  return (
    <div className="w-full">
      {editable && (
        <div className="flex gap-5 w-full">
          <div>
            <ColorPicker
              value={currentColor}
              onChange={handleColorChange}
              showText
            />
          </div>
          <Input
            type="text"
            value={currentTitle}
            onChange={(e) => handleTitleChange(e.target.value)}
            className="w-full"
            placeholder="Enter label text"
          />
        </div>
      )}
      {currentTitle && (
        <div className="w-auto items-center flex mt-4">
          <CTag color={currentColor}>{currentTitle}</CTag>
        </div>
      )}
    </div>
  );
};
